import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismCard } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import SettingsPersonalMfa from 'lumen/components/settings/personal/mfa';
import type HotelSettingsSecurityController from 'lumen/controllers/hotel/settings/security';

interface HotelSettingsSecuritySignature {
  Args: {
    controller: HotelSettingsSecurityController;
    model: unknown;
  };
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.security.description"}}
    @title={{t "settings.security.title"}}
    @type="container"
  >
    <PrismCard class="form-card">
      <:header as |Header|>
        <Header.title>
          {{t "general.password"}}
        </Header.title>
      </:header>

      <:content>
        <div class="flex items-center justify-between">
          <p class="paragraph-300--regular">
            {{t "settings.security.password.password_description"}}
          </p>
          <PrismButton
            @buttonType="secondary"
            @label={{t "settings.security.password.update_password"}}
            @onClick={{@controller.redirectToChangePassword}}
          />
        </div>
      </:content>
    </PrismCard>

    {{#if @controller.access.hasPersonalSettingsMFA}}
      <SettingsPersonalMfa
        @areConfigsLoading={{@controller.areConfigsLoading}}
        @mfaConfigs={{@controller.mfaConfigs}}
        @refreshMfaConfigs={{@controller.refreshMfaConfigs}}
      />
    {{/if}}
  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsSecuritySignature>;
